import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const ProductionSearch = React.lazy(() => import('components/Search/Search'));

function ScreensSearch() {
  return (
    <BaseLayout>
      <DocumentTitle>Production List</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <ProductionSearch />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensSearch;
